import { feedbackSubmitted } from 'owa-search';
import { orchestrator } from 'satcheljs';
import { lazyLogFeedback } from 'owa-search-service';

export default orchestrator(feedbackSubmitted, actionMessage => {
    const { scenario, suggestionSetTraceId, yesSelected, feedbackString } = actionMessage;

    lazyLogFeedback.importAndExecute(
        new Date(),
        suggestionSetTraceId,
        yesSelected,
        feedbackString,
        scenario
    );
});
